export const CUSTOMER_MESSAGES = {
  resentVerificationCode: "We successfully resent your code.",
} as const satisfies Record<string, string>;
